var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78733 6.6367C8.21842 6.22002 8.28859 5.89833 7.39475 5.33916C4.76718 3.69725 1.59122 5.1632 1.16913 8.34769C0.906803 10.3232 2.57251 12.5124 4.48327 12.5545C4.30083 13.3382 2.87801 15.1409 2.26053 16.0704C1.72616 16.8746 0.208348 18.7691 0 19.5485C1.17884 20.3376 2.25189 21.1742 3.47823 21.9881C4.7294 22.8193 5.79165 23.5847 6.99424 24.39C7.44441 18.9861 14.8856 19.2624 14.8856 24.5692C14.8856 26.1226 13.6322 27.6835 12.3746 27.9771C12.7589 28.5514 13.4293 28.8364 13.9885 29.2337C14.5909 29.6611 15.1522 30.0703 15.7837 30.488L19.3699 33L22.8859 28.0872C23.3091 27.4493 23.6405 26.9505 24.0324 26.3644C24.5516 26.7454 24.1911 26.5716 24.6542 26.998C27.638 29.7497 31.5653 27.1794 31.5653 24.2119C31.5653 22.2925 30.0885 20.4121 28.3365 20.2663L33 13.4515C31.9691 12.7606 26.6027 9.23395 26.185 8.60893C26.9341 8.40922 27.5398 7.70108 27.8582 7.05339C28.8838 4.96673 28.1 1.25545 23.8543 1.25545C22.045 1.25545 20.4073 2.97399 20.267 4.66339L16.887 2.30471C16.2415 1.82542 13.901 0.146811 13.2728 0C13.0892 0.686555 9.48255 5.60039 8.78841 6.63562L8.78733 6.6367Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavImg);
export default __webpack_public_path__ + "static/media/navImg.2451d6b39d87bcd5c19611897814852e.svg";
export { ForwardRef as ReactComponent };